/* global NetworkConfig */
import axios from 'axios';

import { helperGetApiHeaders, helperGetApiRoute, apiErrorHandler } from 'helpers/ApiHelper';
import { concatToUrl } from 'helpers/ContentHelper';
import { getPrimetimeDateRange } from 'helpers/DateTimeHelper';

export const FETCH_NAV_SCHEDULE = 'FETCH_NAV_SCHEDULE';

export function fetchNavSchedule(accessToken, deviceId) {
  const { branding } = NetworkConfig;
  const pageType = 'foxPrimetime';
  const dateRange = getPrimetimeDateRange();
  let url = helperGetApiRoute(pageType);
  if (url.indexOf('/live') > 0) {
    url = concatToUrl(url, `network=${branding}`);
    url = url && dateRange ? concatToUrl(url, `dateRange=${dateRange}`) : url;
  }
  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_NAV_SCHEDULE,
    payload: request,
  };
}
